import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

// ============================================================
// Example Component
// ============================================================
// Calendar
const Calendar = () =>
    import(/* webpackChunkName: "extra" */ "@/views/Calendar/Calendar.vue");
// Charts
const Charts = () =>
    import(/* webpackChunkName: "dashboard" */ "@/views/Charts.vue");

// Components pages
const Buttons = () =>
    import(
        /* webpackChunkName: "components" */ "@/views/Components/Buttons.vue"
    );
const Cards = () =>
    import(/* webpackChunkName: "components" */ "@/views/Components/Cards.vue");
const GridSystem = () =>
    import(
        /* webpackChunkName: "components" */ "@/views/Components/GridSystem.vue"
    );
const Notifications = () =>
    import(
        /* webpackChunkName: "components" */ "@/views/Components/Notifications.vue"
    );
const Icons = () =>
    import(/* webpackChunkName: "components" */ "@/views/Components/Icons.vue");
const Typography = () =>
    import(
        /* webpackChunkName: "components" */ "@/views/Components/Typography.vue"
    );

// Dashboard pages
const Dashboard = () =>
    import(
        /* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue"
    );
const AlternativeDashboard = () =>
    import(
        /* webpackChunkName: "dashboard" */ "@/views/Dashboard/AlternativeDashboard.vue"
    );
const Widgets = () =>
    import(/* webpackChunkName: "dashboard" */ "@/views/Widgets.vue");

// Forms pages
const FormElements = () =>
    import(/* webpackChunkName: "forms" */ "@/views/Forms/FormElements.vue");
const FormComponents = () =>
    import(/* webpackChunkName: "forms" */ "@/views/Forms/FormComponents.vue");
const FormValidation = () =>
    import(/* webpackChunkName: "forms" */ "@/views/Forms/FormValidation.vue");

// Maps pages
const GoogleMaps = () =>
    import(/* webpackChunkName: "extra" */ "@/views/Maps/GoogleMaps.vue");
const VectorMaps = () =>
    import(/* webpackChunkName: "extra" */ "@/views/Maps/VectorMaps.vue");

// TableList pages
const RegularTables = () =>
    import(/* webpackChunkName: "tables" */ "@/views/Tables/RegularTables.vue");
const SortableTables = () =>
    import(
        /* webpackChunkName: "tables" */ "@/views/Tables/SortableTables.vue"
    );
const PaginatedTables = () =>
    import(
        /* webpackChunkName: "tables" */ "@/views/Tables/PaginatedTables.vue"
    );

// Pages
const User = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile.vue");
const Pricing = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Pages/Pricing.vue");
const TimeLine = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Pages/TimeLinePage.vue");
const Login = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");
const Home = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Pages/Home.vue");
const Register = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Pages/Register.vue");
const Lock = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Pages/Lock.vue");

const ProfileChangePassword = () =>
    import(/* webpackChunkName: "tables" */ "@/views/Profile/EditPasswordForm.vue");

const ProfileChangeProfile = () =>
    import(/* webpackChunkName: "tables" */ "@/views/Profile/EditProfileForm.vue");

const ForgotPassword = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Pages/ForgotPassword.vue");
const ResetPassword = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Pages/ResetPassword.vue");

// ============================================================
// Stock Component
// ============================================================
const storageList = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/StorageTables.vue");
const partnerList = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/PartnerTables.vue");
const productList = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/ProductTables.vue");
const productWaitShipList = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/ProductWaitShipTables.vue");
const inventoryList = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/InventoryTables.vue");
const inventoryDashboard = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/InventoryDashboard.vue");
const inventoryDashboardV2 = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/InventoryDashboardV2.vue");
const inventoryDetailList = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/InventoryDetailTables.vue");
const InventoryHistoryByStorage = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/InventoryHistoryByStorage.vue");
const InventorySummaryPacking = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/InventorySummaryPacking.vue");
const promotionList = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/PromotionTables.vue");

const inventoryIn = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/InventoryIn.vue");
const inventoryOut = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Stock/InventoryOut.vue");
const inventoryTransfer = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Stock/InventoryTransfer.vue"
    );
const inventoryTransferToLine = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Stock/InventoryTransferToLine.vue"
    );
const inventoryHistory = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Stock/InventoryHistoryTables.vue"
    );
const inventoryHistoryDetail = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Stock/InventoryHistoryDetail.vue"
    );

// ============================================================
// Backoffice Component
// ============================================================
const boOrder = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/OrderTables.vue"
    );
const boOrderForm = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Backoffice/OrderForm.vue");

const boOrderFormQuick = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Backoffice/OrderFormQuick.vue");

const boProduct = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/ProductTables.vue"
    );
const boPlatformProduct = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/PlatformProductTables.vue"
    );
const boPayment = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/PaymentTables.vue"
    );
const boPacking = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/PackingTables.vue"
    );
const boShipping = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/ShippingForm.vue"
    );
const boShippingWithCoupon = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/ShippingFormByLineAutoCloseWithCoupon.vue"
    );

const boShippingWithCouponV2 = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/ShippingFormByLineAutoCloseWithCouponV2.vue"
    );

const boShippingChecking = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/ShippingCheckingForm.vue"
    );
const boShippingByLine = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/ShippingFormByLine.vue"
    );
const boShippingByLineAutoClose = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/ShippingFormByLineAutoClose.vue"
    );

const boShippingAdmin = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/ShippingAdminForm.vue"
    );
const boShippingReturn = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/ShippingReturnForm.vue"
    );
const boShippingReturnV2 = () =>
		import(
			/* webpackChunkName: "pages" */ "@/views/Backoffice/ShippingReturnFormV2.vue"
		);
const boShippingReturnV3 = () =>
		import(
			/* webpackChunkName: "pages" */ "@/views/Backoffice/ShippingReturnFormV3.vue"
		);
const boCustomer = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Backoffice/CustomerTables.vue"
    );

// ============================================================
// PO Component
// ============================================================
const boPO = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/PO/POTables.vue"
    );

const boPOForm = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/PO/POForm.vue"
    );

// ============================================================
// Coupon Component
// ============================================================
const boCoupon = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Coupon/CouponTables.vue"
    );

const boCouponDetail = () =>
        import(
            /* webpackChunkName: "pages" */ "@/views/Coupon/CouponDetailTables.vue"
        );
const boCouponDetailAll = () =>
        import(
            /* webpackChunkName: "pages" */ "@/views/Coupon/CouponDetailAllTables.vue"
        );
const boCouponMember = () =>
        import(
            /* webpackChunkName: "pages" */ "@/views/Coupon/CouponMemberTables.vue"
        );


const boCouponForm = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Coupon/CouponForm.vue"
    );






// ============================================================
// Report Component
// ============================================================

const reportDashboard = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportDashboard.vue"
    );
const reportTeam = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportTeam.vue"
    );

const reportSaleChannel = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportSaleChannel.vue"
    );

const reportProduct = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportProduct.vue"
    );

const reportUser = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportUser.vue"
    );
const reportUserAndProduct = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportUserAndProduct.vue"
    );
const reportSaleChannelAndProduct = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportSaleChannelAndProduct.vue"
    );

const reportSummaryWmsProduct = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportSummaryWmsProduct.vue"
    );
const reportSummaryWms = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportSummaryWms.vue"
    );
const reportSummaryWmsByField = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportSummaryWmsByField.vue"
    );
const reportCommission = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportCommission.vue"
    );
	const reportOrderReturn = () => import(
        /* webpackChunkName: "pages" */ "@/views/Report/ReportOrderReturn.vue"
    );

// ============================================================
// Platform Component
// ============================================================
const platformConnect = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Platform/PlatformConnect.vue"
    );

const platformTiktok = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Platform/TiktokOrderTables.vue"
    );

// ============================================================
// Admin Component
// ============================================================
const adminUser = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Admin/UserTables.vue");

const adminMember = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Admin/MemberTables.vue");

const adminSaleChannel = () =>
    import(
        /* webpackChunkName: "pages" */ "@/views/Admin/SaleChannelTables.vue"
    );

const adminProduct = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Admin/ProductTables.vue");

const adminSkuRandom = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Admin/SkuRandomTables.vue");
const adminCoupon = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Admin/CouponTables.vue");


const adminProductForm = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Admin/ProductForm.vue");
const adminPlatformProduct = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Admin/PlatformProductTables.vue");
const adminPlatformProductForm = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Admin/PlatformProductForm.vue");

const adminPaymentChannel = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Admin/PaymentChannelTables.vue");

// ============================================================
// Platform Statement Component
// ============================================================
const platformStatementList = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Backoffice/PlatformStatementList.vue");
const platformStatementUpload = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Backoffice/PlatformStatementUpload.vue");
const platformStatementDetail = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Backoffice/PlatformStatementDetail.vue");
const platformStatementSummary = () =>
    import(/* webpackChunkName: "pages" */ "@/views/Backoffice/PlatformStatementSummary.vue");

let wmsMenu = {
    path: "/wms",
    component: DashboardLayout,
    redirect: "/wms/inventory",
    name: "wms",
    meta: {
        breadcrumb: "wms.name"
    },
    children: [
        {
            path: "promotion",
            name: "WmsPromotion",
            component: promotionList,
            meta: {
                breadcrumb: "wms.menu.promotion",
                requiresAuth: true
            }
        },
        {
            path: "history",
            name: "WmsInventoryHistory",
            component: inventoryHistory,
            meta: {
                breadcrumb: "wms.menu.inventory_history",
                requiresAuth: true
            }
        },
        {
            path: "historydetail/:id",
            name: "WmsInventoryHistoryDetail",
            component: inventoryHistoryDetail,
            meta: {
                breadcrumb: "wms.menu.inventory_history",
                requiresAuth: true
            }
        },
        {
            path: "inventory/dashboardv1",
            name: "WmsInventoryDashboardv1",
            component: inventoryDashboard,
            meta: {
                breadcrumb: "wms.menu.inventory_dashboard",
                requiresAuth: true
            }
        },
        {
            path: "inventory/dashboard",
            name: "WmsInventoryDashboardV2",
            component: inventoryDashboardV2,
            meta: {
                breadcrumb: "wms.menu.inventory_dashboard",
                requiresAuth: true
            }
        },
        {
            path: "inventory/summary",
            name: "WmsInventory",
            component: inventoryList,
            meta: {
                breadcrumb: "wms.menu.inventory_list",
                requiresAuth: true
            }
        },
        {
            path: "inventory/detail",
            name: "WmsInventoryDetail",
            component: inventoryDetailList,
            meta: {
                breadcrumb: "wms.menu.inventory_list_detail",
                requiresAuth: true
            }
        },
        {
            path: "inventory/storage",
            name: "WmsInventoryHistoryByStorage",
            component: InventoryHistoryByStorage,
            meta: {
                breadcrumb: "wms.menu.inventory_history_storage_list",
                requiresAuth: true
            }
        },
        {
            path: "inventory/packing",
            name: "WmsInventorySummaryPacking",
            component: InventorySummaryPacking,
            meta: {
                breadcrumb: "wms.menu.inventory_summary_packing",
                requiresAuth: true
            }
        },
        {
            path: "inventory/in",
            name: "WmsInventoryIn",
            component: inventoryIn,
            meta: {
                breadcrumb: "wms.menu.inventory",
                requiresAuth: true
            }
        },
        {
            path: "inventory/out",
            name: "WmsInventoryOut",
            component: inventoryOut,
            meta: {
                breadcrumb: "wms.menu.inventory",
                requiresAuth: true
            }
        },
        {
            path: "inventory/transfer",
            name: "WmsInventoryTransfer",
            component: inventoryTransfer,
            meta: {
                breadcrumb: "wms.menu.inventory",
                requiresAuth: true
            }
        },
        {
            path: "inventory/transfertoline",
            name: "WmsInventoryTransferToLine",
            component: inventoryTransferToLine,
            meta: {
                breadcrumb: "wms.menu.inventory_to_line",
                requiresAuth: true
            }
        },
        {
            path: "partner",
            name: "WmsPartner",
            component: partnerList,
            meta: {
                breadcrumb: "wms.menu.partner",
                requiresAuth: true
            }
        },
        {
            path: "product",
            name: "WmsProduct",
            component: productList,
            meta: {
                breadcrumb: "wms.menu.product",
                requiresAuth: true
            }
        },
        {
            path: "product/waitship",
            name: "WmsProductWaitShip",
            component: productWaitShipList,
            meta: {
                breadcrumb: "wms.menu.product",
                requiresAuth: true
            }
        },
        {
            path: "storage",
            name: "WmsStorage",
            component: storageList,
            meta: {
                breadcrumb: "wms.menu.storage",
                requiresAuth: true
            }
        }
    ]
};

let boMenu = {
    path: "/backoffice",
    component: DashboardLayout,
    redirect: "/backoffice/orders",
    name: "BackOffice",
    meta: {
        breadcrumb: "backoffice"
    },
    children: [
        // coupon
        {
            path: "coupon",
            name: "BOCoupon",
            component: boCoupon,
            meta: {
                breadcrumb: "menu.coupon",
                requiresAuth: true
            }
        },
        {
            path: "coupon/detail/:id",
            name: "BOCouponDetail",
            component: boCouponDetail,
            meta: {
                breadcrumb: "menu.coupon",
                requiresAuth: true
            }
        },
        {
            path: "coupon/all/:id",
            name: "BOCouponDetail",
            component: boCouponDetailAll,
            meta: {
                breadcrumb: "menu.coupon",
                requiresAuth: true
            }
        },


        {
            path: "coupon/member/:id",
            name: "BOCouponDetail",
            component: boCouponMember,
            meta: {
                breadcrumb: "menu.coupon",
                requiresAuth: true
            }
        },

        {
            path: "coupon/:action",
            name: "BOCouponForm",
            component: boCouponForm,
            meta: {
                breadcrumb: "menu.coupon",
                requiresAuth: true
            }
        },

        // PO
        {
            path: "po",
            name: "PO",
            component: boPO,
            meta: {
                breadcrumb: "menu.po",
                requiresAuth: true
            }
        },
        {
            path: "po/:action",
            name: "POForm",
            component: boPOForm,
            meta: {
                breadcrumb: "menu.po",
                requiresAuth: true
            }
        },
        {
            path: "orders",
            name: "BOOrders",
            component: boOrder,
            meta: {
                breadcrumb: "orders",
                requiresAuth: true
            }
        },
        {
            path: "orders/:id",
            name: "BOOrders",
            component: boOrderForm,
            meta: {
                breadcrumb: "order_form",
                requiresAuth: true
            }
        },
        {
            path: "ordersv2/:id",
            name: "BOOrdersQuick",
            component: boOrderFormQuick,
            meta: {
                breadcrumb: "order_form",
                requiresAuth: true
            }
        },
        {
            path: "products",
            name: "BOProduct",
            component: boProduct,
            meta: {
                breadcrumb: "products",
                requiresAuth: true
            }
        },

        {
            path: "packings",
            name: "BOPacking",
            component: boPacking,
            meta: {
                breadcrumb: "packings",
                requiresAuth: true
            }
        },
		// {
        //     path: "packings/shipping",
        //     name: "BOShipping",
        //     component: boShipping,
        //     meta: {
        //         breadcrumb: "shipping",
        //         requiresAuth: true
        //     }
        // },

		{
            path: "packings/shipping/checking",
            name: "BOShippingChecking",
            component: boShippingChecking,
            meta: {
                breadcrumb: "shipping",
                requiresAuth: true
            }
        },
		{
            path: "packings/shipping/coupon",
            name: "BOShippingCoupon",
            component: boShippingWithCoupon,
            meta: {
                breadcrumb: "shipping",
                requiresAuth: true
            }
        },
		{
            path: "packings/shipping/coupon/v2",
            name: "BOShippingCouponV2",
            component: boShippingWithCouponV2,
            meta: {
                breadcrumb: "shipping",
                requiresAuth: true
            }
        },
		{
            path: "packings/shipping/line",
            name: "BOShippingLine",
            component: boShippingByLine,
            meta: {
                breadcrumb: "shipping",
                requiresAuth: true
            }
        },
		{
            path: "packings/shipping/autoclose",
            name: "BOShippingLineAutoClose",
            component: boShippingByLineAutoClose,
            meta: {
                breadcrumb: "shipping",
                requiresAuth: true,
				requiresAdmin: true
            }
        },
		{
            path: "packings/shipping/admin",
            name: "BOShippingAdmin",
            component: boShippingAdmin,
            meta: {
                breadcrumb: "shipping",
                requiresAuth: true
            }
        },
		{
            path: "packings/shipping/returnv0",
            name: "BOShippingReturn",
            component: boShippingReturn,
            meta: {
                breadcrumb: "shipping_return",
                requiresAuth: true,
                requiresOrderReturn: true
            }
        },
		{
            path: "packings/shipping/returnv2",
            name: "BOShippingReturnV2",
            component: boShippingReturnV2,
            meta: {
                breadcrumb: "shipping_return",
                requiresAuth: true,
                requiresOrderReturn: true
            }
        },
		{
            path: "packings/shipping/return",
            name: "BOShippingReturnV3",
            component: boShippingReturnV3,
            meta: {
                breadcrumb: "shipping_return",
                requiresAuth: true,
                requiresOrderReturn: true
            }
        },

        {
            path: "payments",
            name: "BOPayment",
            component: boPayment,
            meta: {
                breadcrumb: "payments",
                requiresAuth: true
            }
        },
		{
            path: "customers",
            name: "BOCustomer",
            component: boCustomer,
            meta: {
                breadcrumb: "customer",
                requiresAuth: true
            }
        },
		{

            path: "reports/dashboard",
            name: "ReportTeam",
            component: reportDashboard,
            meta: {
                breadcrumb: "report",
                requiresAuth: true
            }
		},
        {
            path: "reports/team",
            name: "ReportTeam",
            component: reportTeam,
            meta: {
                breadcrumb: "report_by_team",
                requiresAuth: true
            }
        },
        {
            path: "reports/sale-channel",
            name: "ReportSaleChannel",
            component: reportSaleChannel,
            meta: {
                breadcrumb: "report_by_sale_channel",
                requiresAuth: true
            }
        },
        {
            path: "reports/product",
            name: "ReportProduct",
            component: reportProduct,
            meta: {
                breadcrumb: "report_by_product",
                requiresAuth: true
            }
        },
        {
            path: "reports/salechannel-product",
            name: "ReportSaleChannelAndProduct",
            component: reportSaleChannelAndProduct,
            meta: {
                breadcrumb: "report_by_sale_channel_product",
                requiresAuth: true
            }
        },

        {
            path: "reports/user-product",
            name: "ReportUserAndProduct",
            component: reportUserAndProduct,
            meta: {
                breadcrumb: "report_by_user_product",
                requiresAuth: true
            }
        },
        {
            path: "reports/user",
            name: "ReportUser",
            component: reportUser,
            meta: {
                breadcrumb: "report_by_user",
                requiresAuth: true
            }
        },
        {
            path: "reports/summary-wms",
            name: "ReportSummaryWms",
            component: reportSummaryWms,
            meta: {
                breadcrumb: "report_wms_summary",
                requiresAuth: true
            }
        },
        {
            path: "reports/summary-wms-product",
            name: "ReportSummaryWmsProduct",
            component: reportSummaryWmsProduct,
            meta: {
                breadcrumb: "report_wms_summary_product",
                requiresAuth: true
            }
        },
        {
            path: "reports/summary-wms-field",
            name: "ReportSummaryWmsByField",
            component: reportSummaryWmsByField,
            meta: {
                breadcrumb: "report_wms_summary_field",
                requiresAuth: true
            }
        },
        {
            path: "reports/commission",
            name: "ReportCommission",
            component: reportCommission,
            meta: {
                breadcrumb: "report_commission",
                requiresAuth: true
            }
        },
        {
            path: "reports/order-return",
            name: "ReportOrderReturn",
            component: reportOrderReturn,
            meta: {
                breadcrumb: "report_order_return",
                requiresAuth: true
            }
        },
        // Platform Statement
        {
            path: "platform-statement",
            name: "PlatformStatementList",
            component: platformStatementList,
            meta: {
                breadcrumb: "platform_statement.list",
                requiresAuth: true
            }
        },
        {
            path: "platform-statement/upload",
            name: "PlatformStatementUpload",
            component: platformStatementUpload,
            meta: {
                breadcrumb: "platform_statement.upload",
                requiresAuth: true
            }
        },
        {
            path: "platform-statement/summary",
            name: "PlatformStatementSummary",
            component: platformStatementSummary,
            meta: {
                breadcrumb: "platform_statement.summary",
                requiresAuth: true
            }
        },
        {
            path: "platform-statement/:id",
            name: "PlatformStatementDetail",
            component: platformStatementDetail,
            meta: {
                breadcrumb: "platform_statement.detail",
                requiresAuth: true
            }
        },


    ]
};

let profileMenu = {
    path: "/profile",
    component: DashboardLayout,
    redirect: "/profile/me",
    name: "profile`",
    meta: {
        breadcrumb: "profile.info"
    },
    children: [
        {
            path: "me",
            name: "ProfileChange",
            component: ProfileChangeProfile,
            meta: {
                breadcrumb: "profile.info",
                requiresAuth: true
            }
        },
        {
            path: "changepasword",
            name: "ProfileChangePassword",
            component: ProfileChangePassword,
            meta: {
                breadcrumb: "profile.change_password",
                requiresAuth: true
            }
        }
    ]
};

let pagesMenu = {
    path: "/pages",
    component: DashboardLayout,
    name: "Pages",
    redirect: "/pages/user",
    children: [
        {
            path: "user",
            name: "User Page",
            component: User
        },
        {
            path: "timeline",
            name: "Timeline Page",
            component: TimeLine
        }
    ]
};

let adminMenu = {
    path: "/admin",
    component: DashboardLayout,
    name: "Admin",
    redirect: "/admin/user",
    meta: {
        breadcrumb: "bc_admin"
    },
    children: [
        {
            meta: {
                breadcrumb: "platform_connect",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "platform",
            name: "platform",
            component: platformConnect
        },
        {
            meta: {
                breadcrumb: "menu.user",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "user",
            name: "user",
            component: adminUser
        },
		{
            meta: {
                breadcrumb: "menu.member",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "member",
            name: "member",
            component: adminMember
        },
		{
            meta: {
                breadcrumb: "sale_channel",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "sale-channel",
            name: "sale-channel",
            component: adminSaleChannel
        },
		{
            meta: {
                breadcrumb: "product",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "product",
            name: "product",
            component: adminProduct
        },
		{
            meta: {
                breadcrumb: "product_form",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "product/form",
            name: "product_form",
            component: adminProductForm
        },
		{
            meta: {
                breadcrumb: "product",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "product/:platform",
            name: "product",
            component: adminPlatformProduct
        },
		{
            meta: {
                breadcrumb: "product_form",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "product/:platform/:id",
            name: "platform_product_form",
            component: adminPlatformProductForm
        },
		{
            meta: {
                breadcrumb: "payment_channel",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "payment",
            name: "payment",
            component: adminPaymentChannel
        },
		{
            meta: {
                breadcrumb: "sku_random",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "skurandom",
            name: "skurandom",
            component: adminSkuRandom
        },
		{
            meta: {
                breadcrumb: "coupon",
				requiresAuth: true,
				requiresAdmin: true
            },
            path: "coupon",
            name: "coupon",
            component: adminCoupon
        },
    ]
};

let authPages = {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    children: [
        {
            path: "/login",
            name: "Login",
            component: Login,
            meta: {
                noBodyBackground: true
            }
        },
        {
            path: "/forgotpassword",
            name: "forgot_password",
            component: ForgotPassword,
            meta: {
                noBodyBackground: true
            }
        },
        {
            path: "/resetpassword",
            name: "reset_password",
            component: ResetPassword,
            meta: {
                noBodyBackground: true
            }
        },
        {
            path: "/home",
            name: "Home",
            component: Login
        },
        {
            path: "/register",
            name: "Register",
            component: Register
        },
        {
            path: "/pricing",
            name: "Pricing",
            component: Pricing
        },
        {
            path: "/lock",
            name: "Lock",
            component: Lock
        },

        { path: "*", component: NotFound }
    ]
};

const routes = [
    wmsMenu,
    boMenu,
    profileMenu,
    adminMenu,

    // componentsMenu,
    // formsMenu,
    // tablesMenu,
    // mapsMenu,
    pagesMenu,
    {
        path: "/",
        component: DashboardLayout,
        redirect: "/backoffice",
        name: "Dashboard"
    },
    authPages
];

export default routes;
